import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import theme from 'theme/index';
import { getInheritedPermissionsForObjectIdentityId } from 'auth/store/permissions/selectors';
import { updatePermission } from 'auth/store/permissions/actions';

const SmallButton = styled.span`
    &:hover {
      cursor: pointer;
      color: ${theme.colors.primary};
    }
`;

class PermissionQuickActionButton extends Component {
  handleClick = () => {
    const {
      permissions, updatePermission, objectIdentityId, columns, isGranting,
    } = this.props;
    const newPermissions = {
      ...permissions,
      // Always set oid, otherwise we might change the parent permissions
      // The inherited permission can only be changed at the parent
      objectIdentityId,
    };
    columns.forEach(col => newPermissions[col] = isGranting); // eslint-disable-line
    updatePermission(newPermissions);
  };


  render() {
    const { children } = this.props;

    return (
      <SmallButton
        onClick={this.handleClick}
      >
        {children}
      </SmallButton>
    );
  }
}
PermissionQuickActionButton.propTypes = {
  updatePermission: PropTypes.func.isRequired,
  permissions: PropTypes.objectOf(PropTypes.any),
  objectIdentityId: PropTypes.string,
  columns: PropTypes.arrayOf(PropTypes.any).isRequired,
  isGranting: PropTypes.bool.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};
PermissionQuickActionButton.defaultProps = {
  objectIdentityId: null,
  permissions: null,
  children: [],
};

const mapStateToProps = (state, props) => ({
  permissions: getInheritedPermissionsForObjectIdentityId(state, props.objectIdentityId),
});

const mapDispatchToProps = {
  updatePermission,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PermissionQuickActionButton);
